import { render, staticRenderFns } from "./allPermission.vue?vue&type=template&id=4f75d1aa&scoped=true&"
import script from "./allPermission.vue?vue&type=script&lang=js&"
export * from "./allPermission.vue?vue&type=script&lang=js&"
import style0 from "./allPermission.vue?vue&type=style&index=0&id=4f75d1aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f75d1aa",
  null
  
)

export default component.exports